import type { MessageAdReadingPaneProps } from './components/MessageAdReadingPane';
import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const messageAdReadingPaneLazyModule: LazyModule<typeof lazyIndex> = new LazyModule<
    typeof lazyIndex
>(() => import(/* webpackChunkName: "MessageAdReadingPane" */ './lazyIndex'), {
    name: 'MessageAdReadingPane',
});

// Export delay loaded components
export const MessageAdReadingPane: LazyComponent<MessageAdReadingPaneProps, unknown, void> =
    createLazyComponent(messageAdReadingPaneLazyModule, m => m.MessageAdReadingPane);
